// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SNAPSHOT_ACTIONS = {
    REVERT: 'revert',
    DELETE: 'delete',
};
